import { enJourLisible, VERDICT, type Decision, type Verdict } from '../verification/verdict';

/**
 * Le verdict, en signalétique.
 *
 * Une couleur, un mot, une icône — dans cet ordre de lecture. Le détail vient
 * après, pour l'agent qui veut consigner le contrôle ; il ne doit jamais
 * disputer la place au verdict.
 */

const MOT: Readonly<Record<Verdict, string>> = {
  valide: 'Valide',
  expire: 'Expiré',
  retire: 'Retiré',
  faux: 'Faux',
  inconnu: 'Inconnu',
};

/**
 * Glyphes typographiques plutôt qu'images : zéro octet réseau, rendu identique
 * partout, et lisibles sur un écran délavé par le soleil.
 */
const ICONE: Readonly<Record<Verdict, string>> = {
  valide: '✓',
  expire: '⌛',
  retire: '⊘',
  faux: '✕',
  inconnu: '?',
};

export interface ProprietesResultat {
  readonly decision: Decision;
  readonly onRecommencer: () => void;
}

export function EcranResultat({ decision, onRecommencer }: ProprietesResultat) {
  const { verdict, titre } = decision;

  return (
    <div className="verify-ecran" data-verdict={verdict}>
      <div className="verify-verdict">
        {/* Le mot suit l'icône et la couleur : c'est lui que lit un lecteur
            d'écran, et lui qui tranche pour un agent daltonien. */}
        <span className="verify-verdict__icone" aria-hidden="true">
          {ICONE[verdict]}
        </span>
        <h1 className="verify-verdict__mot" role="status">
          {MOT[verdict]}
        </h1>
        <p className="verify-verdict__explication">{decision.explication}</p>

        {decision.revocationNonControlee && (
          <p className="verify-reserve">
            Contrôle hors ligne : une suspension prononcée récemment ne peut pas être vue. Refaites
            le contrôle avec du réseau si vous avez un doute.
          </p>
        )}
      </div>

      {titre !== null && (
        <dl className="verify-detail">
          <div>
            <dt>Numéro</dt>
            <dd>{titre.numeroOfficiel}</dd>
          </div>
          <div>
            <dt>Embarcation</dt>
            <dd>{titre.immatriculation}</dd>
          </div>
          <div>
            <dt>Nature</dt>
            <dd>{titre.type === 'licence' ? 'Licence' : 'Permis'}</dd>
          </div>
          <div>
            <dt>Expire le</dt>
            <dd>{enJourLisible(titre.dateExpiration)}</dd>
          </div>
        </dl>
      )}

      <div className="verify-actions">
        <button
          type="button"
          className="verify-bouton verify-bouton--principal"
          onClick={onRecommencer}
        >
          Contrôler un autre titre
        </button>
      </div>
    </div>
  );
}

export { VERDICT };
